import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

interface AdminTab {
  label: string;
  route: string;
}

export const USERS_ADMIN_BASE = "/menu/usersAdmin";

/**
 * Shell da Gestão de usuários, no mesmo molde do hub admin do Smart Review: um
 * po-page com po-tabs nativos que dirigem rotas filhas (Usuários, Áreas,
 * Tribes, Auditoria). Cada aba é um po-page-list próprio.
 */
@Component({
  selector: "app-area-tribe-admin",
  templateUrl: "./area-tribe-admin.component.html",
  styleUrls: ["./area-tribe-admin.component.css"],
})
export class AreaTribeAdminComponent implements OnInit, OnDestroy {
  readonly tabs: Array<AdminTab> = [
    { label: "Usuários", route: `${USERS_ADMIN_BASE}/users` },
    { label: "Áreas", route: `${USERS_ADMIN_BASE}/areas` },
    { label: "Tribes", route: `${USERS_ADMIN_BASE}/tribes` },
    { label: "Auditoria", route: `${USERS_ADMIN_BASE}/audit` },
  ];

  private activeRoute = "";
  private readonly subs = new Subscription();

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.activeRoute = this.router.url;
    this.subs.add(
      this.router.events
        .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
        .subscribe((e) => (this.activeRoute = e.urlAfterRedirects)),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  isActive(tab: AdminTab): boolean {
    return this.activeRoute.split("?")[0].startsWith(tab.route);
  }

  navigate(tab: AdminTab): void {
    if (!this.isActive(tab)) {
      this.router.navigateByUrl(tab.route);
    }
  }
}
